import React from 'react';
import { IconButton, Fade } from '@chakra-ui/react';
import { ArrowUpIcon } from '@chakra-ui/icons';
import { IconWrapper } from '../../../shared/components';

/**
 * Props for the ScrollToTopPresentation component
 */
export interface ScrollToTopPresentationProps {
  /** Whether the button should be visible */
  isVisible: boolean;
  
  /** Function to handle the click event */
  onClick: () => void;
}

/**
 * Presentation component for the ScrollToTop button
 */
const ScrollToTopPresentation: React.FC<ScrollToTopPresentationProps> = ({ 
  isVisible, 
  onClick 
}) => {
  return (
    <Fade in={isVisible}>
      <IconButton
        aria-label="Scroll to top"
        icon={<IconWrapper icon={ArrowUpIcon} size="2.0em" />}
        size="lg"
        colorScheme="teal"
        rounded="full"
        position="fixed"
        bottom="4"
        right="4"
        zIndex="tooltip"
        onClick={onClick}
        boxShadow="lg"
      />
    </Fade>
  );
};

export default ScrollToTopPresentation;